/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * TextBlockStatus component styles
 *
 * @author Yakov Gushchin
 * @version 1.10.0
 * @since 1.10.0
 */

import styled from 'styled-components';

export const TextBlockStatusStyled = styled.div`
    display: flex;
    align-items: center;

    .status-icon {
        margin-right: 12px;
        min-width: 20px;
    }
`;
